import { Component, OnInit } from '@angular/core';
import { DictionaryMessageTypeFuelAppService } from '../../../app/shared/services/dictionary-message-type-fuel-app-service';
import { DictionaryMessageTypeFuelAppEntity } from '../../../app/shared/types/dictionary-message-type-fuel-app-entity';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';
import { AddMessageTypeDialogComponent } from 'src/components/pages/dictionaries-message-types-fuel-app-tab/add-message-type-dialog/add-message-type-dialog.component';
import { DictionaryType } from '../../shared/dictionaries-layout';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from '../../../app/shared/fca-data-table';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorDialogComponent } from '../../shared/error-dialog/error-dialog.component';

@Component({
  standalone: false,
  selector: 'dictionary-message-types-fuel-app-tab',
  templateUrl: './message-types-fuel-app.component.html',
  styleUrls: ['./message-types-fuel-app.component.scss'],
})
export class DictionaryMessageTypesFuelAppTab implements OnInit {
  data: DictionaryMessageTypeFuelAppEntity[] | null = null;
  pageSize = 10;

  dataDefinition: DataTableDataDefinition<DictionaryMessageTypeFuelAppEntity> = [
    {
      name: '',
      allowGroup: true,
      columns: [
        {
          fieldName: 'messageType',
          caption: 'MESSAGE TYPE',
          valueType: 'text',
          editable: false,
          deletable: true,
        },
      ],
    },
  ];

  constructor(
    private dataService: DictionaryMessageTypeFuelAppService,
    public dialog: MatDialog
  ) {}

  title = 'Dictionary';
  dictionaryType = DictionaryType.MessageTypesFuelApp;

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.dataService.getAll().subscribe((receivedData) => {
      this.data = receivedData;
    });
  }

  customButtons: CustomButtonDefinition<DictionaryMessageTypeFuelAppEntity>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.confirmDelete.bind(this) as (x: any) => {},
    },
  ];

  isDialogOpen = false;

  addMessageType() {
    if (this.isDialogOpen) {
      return;
    }

    this.isDialogOpen = true;

    const dialogRef = this.dialog.open(AddMessageTypeDialogComponent, {
      width: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      data: { name: '' },
    });

    dialogRef.componentInstance.onAddCallback = (messageType: string) => {
      this.dataService.add({ messageType: messageType, id: undefined }).subscribe({
        next: () => {
          this.loadData();
          dialogRef.close();
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 409) {
            this.dialog.open(ErrorDialogComponent, {
              data: { message: 'This message type already exists in the system.' },
            });
          }
        },
      });
    };

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
  }

  confirmDelete(messageType: DictionaryMessageTypeFuelAppEntity) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes',
        },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.dataService.delete(messageType).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error: HttpErrorResponse) => {
            if (error.status === 400 || error.status === 409) {
              const message = (error.error?.Message || error.error?.message || 'This message type is currently used in the system.').replace(/\n/g, '<br>');
              this.dialog.open(ErrorDialogComponent, {
                width: '350px',
                data: {
                  title: 'Attention',
                  message: message
                },
              });
            }
          },
        });
      }
    });
  }
}

